<template>
  <div class="mt-3 ml-3 mr-3">
    <h3>{{category}} > {{subcategory}} </h3>
    <b-container fluid>
      <b-row>
        <b-col lg="3" class="hide-by-width">
          <category-tree :current-category="category"></category-tree>
        </b-col>
        <b-col>
          <b-row>
            <b-col class="mt-2">
              <!-- <b-table striped hover :items="products" :fields="ProductFields">
                <template #cell(ItemNumber)="data">
                  <b-link :to="{ name: 'ProductDetail', query: { number: data.item.ItemNumber }}">{{data.item.ItemNumber}}</b-link>
                </template>
                <template #cell(Name)="data">
                  <span>{{ data.item.Name }}</span>
                </template>
                <template #cell(Price)="data">
                  <span> {{ data.item.Price | toCurrency }}</span>
                </template>
                <template #cell(Quantity)="data">
                  <span> 
                    <b-form-input :state="data.item.Qty > 0 ? ProductQtyValid(data.item) : null" :id="`QtyInput${data.index}`" type="number" v-model="data.item.Qty" />
                    <b-form-text v-if="!ProductMeetsMin(data.item)">Minimum order quantity is {{data.item.QuantityMin}}</b-form-text>
                    <b-form-text v-if="!ProductMeetsStepSize(data.item)">Must order in multiples of {{data.item.QuantityStepSize}}</b-form-text>
                    <b-form-text v-if="!ProductMeetsMax(data.item)">Maximum order quantity is {{data.item.QuantityMax}}</b-form-text>
                  </span>
                </template>
              </b-table> -->
              <b-row>
                <b-col cols="7">
                  <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="products && products.length || 0"
                  />
                </b-col>
                <b-col cols="5">
                  <div style="display: flex; justify-content: flex-end">
                    <!-- <b-btn @click="AddToCart" :disabled="HasInvalidQty">Add to Cart</b-btn> -->
                  </div>
                </b-col>
              </b-row>
              <b-row v-if="NoProductsFound">
                <b-col>
                  <b-alert show variant="danger">No products found.</b-alert>
                </b-col>
              </b-row>
              <b-row v-if="!products">
                <b-col>
                  <b-alert show variant="info">Loading....</b-alert>
                </b-col>
              </b-row>
              <div v-if="products">
                    
                <!-- {{products.length}} -->
                <b-card-group deck>
                  <b-card v-for="(item, index) in visibleProducts" :key="item.Oid"
                    :title="item.Name"
                    :img-src="item.ImageLink || './static/NoImage.jpg'"
                    img-top
                    style=""
                    class="flex-card mb-4"
                    body-class="centered"
                  >
                    <b-card-text class="centered">{{item.Description}}</b-card-text>
                    <b-card-text class="centered">Carton Quantity: {{item.CartonQuantity}}</b-card-text>
                    <b-card-text v-if="ShowPrices" class="centered">${{item.Price}}/{{item.UnitOfMeasure}}</b-card-text>
                    <template #footer>
                      <b-input-group>
                        <b-input 
                          type="number" 
                          v-model="item.Qty" 
                          :state="item.Qty > 0 ? ProductQtyValid(item) : null"
                          :id="`QtyInput${index}`"
                          @keyup.native.enter="OnQtyEnter(item)"
                        />
                        <template #append>
                          <b-button @click="AddToCart(item)"><i class="fa fa-shopping-cart" aria-hidden="true" /> Add To Cart</b-button>
                        </template>
                      </b-input-group>
                      <b-form-text v-if="!ProductMeetsMin(item)">Minimum order quantity is {{Math.max(categoryData.MinBuy, item.QuantityMin)}}</b-form-text>
                      <b-form-text v-if="!ProductMeetsStepSize(item)">Must order in multiples of {{item.QuantityStepSize}}</b-form-text>
                      <b-form-text v-if="!ProductMeetsMax(item)">Maximum order quantity is {{tem.QuantityMax}}</b-form-text>
                      <b-card-text>Total Units: {{item.CartonQuantity * item.Qty}}</b-card-text>
                    </template>
                  </b-card>
                </b-card-group>
              </div>

              <b-row>
                <b-col cols="7">
                  <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="products && products.length || 0"
                  />
                </b-col>
                <b-col cols="5">
                  <div style="display: flex; justify-content: flex-end">
                    <!-- <b-btn @click="AddToCart" :disabled="HasInvalidQty">Add to Cart</b-btn> -->
                  </div>
                </b-col>
              </b-row>

              <!-- <b-table striped hover :items="products" :fields="ProductFields">
                <template #cell(Image)="data">
                  <b-img thumbnail fluid :src="data.item.ImageLink || './static/NoImage.jpg'" alt="Thumbnail" width="100" height="100" />
                </template>
                <template #cell(ItemNumber)="data">
                  <b-link :to="{ name: 'ProductDetail', query: { number: data.item.ItemNumber }}">{{data.item.ItemNumber}}</b-link>
                </template>
                <template #cell(Name)="data">
                  <span>{{ data.item.Name }}</span>
                </template>
                <template #cell(Quantity)="data">
                  <div> 
                    <b-form-input :state="data.item.Qty > 0 ? ProductQtyValid(data.item) : null" :id="`QtyInput${data.index}`" type="number" v-model="data.item.Qty" @keyup.native.enter="OnQtyEnter(data)"/>
                    <b-form-text v-if="!ProductMeetsMin(data.item)">Minimum order quantity is {{data.item.QuantityMin}}</b-form-text>
                    <b-form-text v-if="!ProductMeetsStepSize(data.item)">Must order in multiples of {{data.item.QuantityStepSize}}</b-form-text>
                    <b-form-text v-if="!ProductMeetsMax(data.item)">Maximum order quantity is {{data.item.QuantityMax}}</b-form-text>
                  </div>
                </template>
                <template #cell(NumberOfUnits)="data">
                  <span>{{ data.item.CartonQuantity * data.item.Qty }}</span>
                </template>
              </b-table> -->
            </b-col>
          </b-row>
          <b-row v-if="MoreAvailable" class="mt-2 text-center">
            <b-col> 
              <b-btn
                :disabled="fetchingProducts"
                v-on:click="loadMoreProducts"
                variant="info"
              >{{LoadMoreCaption}}</b-btn>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ProductService, {isChildOfShowAllRootCategory} from "../services/ProductService";
import store from "@/store.js";
import NProgress from "nprogress";
import ConfigService from "@/services/ConfigService";
import CategoryTree from "./Nav/CategoryTree";
import _ from 'lodash';

import ShowPrices from '@/mixins/ShowPrices';

function canShowPrices() {
  return !(_.find(store.state.auth.roles, i => _.toUpper(i) === "HIDEPRICES"));
}

function GetProducts(category, skip, done, showPrices) {
  var orderbyColumn = "Name";
  // var criteria = `[Tags][Name = '${category.Tag}'] || Group = '${category.Group}'`;
  var criteria = `ProductCategory.FullName = '${category.FullName}'`;

  if (store.state.auth.userInfo && !isChildOfShowAllRootCategory(category)) {
    orderbyColumn = "ProductService.Name";
    // criteria = `[ProductService.Tags][Name = '${category.Tag}'] || ProductService.Group = '${category.Group}'`;
    criteria = `ProductService.ProductCategory.FullName = '${category.FullName}'`;
  }

  // var response = await  ProductService.GetProducts(criteria, orderbyColumn, skip, 50, category);
  // const products = response.data;
      
  // _.forEach(products, i => {
  //   i.Qty = 0;

  //   if(self.ShowPrices) {
  //     i.Price = i.PriceListPrice;
  //     // var priceResp = await ProductService.GetPrice(i.Oid);
  //     // if(priceResp.data.length > 0) {
  //     //   i.Price = priceResp.data[0].Price;
  //     // }
  //   }
  // });
  // done(null, products);
    // .catch(() => {
    //   done("unable to get products");
    // });

  ProductService.GetProducts(criteria, orderbyColumn, skip, 50, category)
    .then(response => {
      const products = response.data;
      
      _.forEach(products, i => {
      //changed 06/02/2025 - ticket #3597
        //i.Qty = 0;

        if(showPrices && i.PriceListPrice) {
          i.Price = i.PriceListPrice;
        }
      });
      done(null, products);
    })
    .catch(() => {
      done("unable to get products");
    });
}

export default {
  name: "CategoryProductList",
  props:{
    category: {
      type: String,
      required: true
    },
    subcategory: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      error: null,
      products: null,
      fetchingProducts: false,

      currentPage: 1,
      perPage: 9,
      categoryData: null,
    };
  },
  computed: {
    ProductFields() {
      return [
        { key: 'Image'}, 
        { key: 'ItemNumber'}, 
        { key: 'Description' },
        { key: 'CartonQuantity', label: 'Box Quantity' },
        { key: 'Quantity', label: 'Number of Boxes Required', class: "text-right"},
        { key: 'NumberOfUnits', label: 'Number of Units' },
      ];
    },
    visibleProducts() {
      return this.products.slice(this.perPage * (this.currentPage - 1), this.perPage * this.currentPage)
    },
    HasInvalidQty() {
      var itemsWithQty = _.filter(this.products, i => i.Qty > 0 && !this.ProductQtyValid(i));
      return itemsWithQty.length > 0;
    },
    MoreAvailable: function() {
      return (
        this.products == null ||
        (this.products.length > 0 && this.products.length % 12 === 0)
      );
    },
    NoProductsFound: function() {
      return this.products != null && this.products.length == 0;
    },
    LoadMoreCaption: function() {
      return this.fetchingProducts ? "Loading..." : "More";
    },
  },
  beforeRouteEnter(to, from, next) {
    ConfigService.GetCatalog().then(c => {
      const rootCat = _.find(
        c,
        i => _.toUpper(i.Name) == _.toUpper(to.params.category)
      );
      const childCat = _.find(
        rootCat.Items,
        i => _.toUpper(i.Name) == _.toUpper(to.params.subcategory)
      );
      GetProducts(childCat, 0, (err, products) => {
        next(vm => {
          vm.setData(err, products);
          vm.categoryData = childCat;
        });
      }, canShowPrices());
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.products = null;
    ConfigService.GetCatalog().then(c => {
      const rootCat = _.find(
        c,
        i => _.toUpper(i.Name) == _.toUpper(to.params.category)
      );
      const childCat = _.find(
        rootCat.Items,
        i => _.toUpper(i.Name) == _.toUpper(to.params.subcategory)
      );
      this.categoryData = childCat;

      GetProducts(childCat, 0, (err, products) => {
        this.setData(err, products);
        next();
      }, this.ShowPrices);
    });

  },
  methods: {
    setData(err, products) {
      if (err) {
        this.error = err.toString();
      } else {
        this.products = products;
      }
    },
    loadMoreProducts() {
      this.fetchingProducts = true;
      NProgress.start();
      NProgress.set(0.1);
      GetProducts(this.criteria, this.products.length, (err, products) => {
        this.products = this.products.concat(products);
        this.fetchingProducts = false;
        setTimeout(() => NProgress.done(), 500);
      }, this.ShowPrices);
    },
    navigateToProduct(number) {
      this.$router.push({ name: "ProductDetail", query: { number: number } });
    },
    ProductMeetsMin(product){
      var applicableMin = Math.max(this.categoryData.MinBuy, product.QuantityMin);
      if(product.Qty > 0 && applicableMin > 0) {
        return product.Qty >= applicableMin;
      }
      return true;
    },
    ProductMeetsMax(product){
      if(product.Qty > 0 && product.QuantityMax > 0) {
        return product.Qty <= product.QuantityMax;
      }
      return true;
    },
    ProductMeetsStepSize(product){
      if(product.Qty > 0 && product.QuantityStepSize > 0) {
        return product.Qty % product.QuantityStepSize == 0;
      }
      return true;
    },
    ProductQtyValid(product) {
        if(!this.ProductMeetsMin(product) || 
          !this.ProductMeetsMax(product) || 
          !this.ProductMeetsStepSize(product)) {
            return false;
        }
        return true;
    },
    async AddToCart(specificItem) {
      var category = `${this.category}/${this.subcategory}`;
      debugger
      if(specificItem) {
        specificItem.ProductCategory = category;
        debugger
        this.$store.commit("AddToCart", specificItem);

        this.$toasted
          .success("Added " + specificItem.Name + " products to Cart")
          .goAway(3000);
      }
      else {
        var itemsWithQty = _.filter(this.products, i => i.Qty > 0);
debugger;
        _.forEach(itemsWithQty, i=> {
          i.ProductCategory = category;
          this.$store.commit("AddToCart", i);
        });
        
        this.$toasted
          .success("Added " + itemsWithQty.length + " products to Cart")
          .goAway(3000);
      }
    }
  },
  components: {
    CategoryTree
  },
  mixins: [ShowPrices]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card:hover {
  background: #f1f2f6;
  cursor: pointer;
}

.card-img-top {
  height: 15vw;
  object-fit: scale-down;
}

.centered {
  text-align: center;
}

.flex-card {
  flex: 0 0 auto;
  max-width: 400px;
  min-width: 400px;
}

@media screen and (max-width: 768px) {
  .hide-by-width {
    display: none;
  }

  .flex-card {
    min-width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CategoryProductList.vue